const TOKEN_COOKIE_NAME = 'auth_token'

export function isAuthenticated() {
    return !!getToken()
}

export function authenticateSuccess(token) {
    _setCookie(TOKEN_COOKIE_NAME, token, 7)
}

export function logout() {
    _setCookie(TOKEN_COOKIE_NAME, '', 0)
}

export function getToken() {
    return _getCookie(TOKEN_COOKIE_NAME)
}

function _getCookie(name) {
    let start, end
    if (document.cookie.length > 0) {
        start = document.cookie.indexOf(name + '=')
        if (start !== -1) {
            start = start + name.length + 1
            end = document.cookie.indexOf(';', start)
            if (end === -1) {
                end = document.cookie.length
            }
            return unescape(document.cookie.substring(start, end))
        }
    }
    return ''
}

function _setCookie(name, value, expire) {
    let date = new Date()
    date.setDate(date.getDate() + expire)
    document.cookie = name + '=' + escape(value) + '; path=/' +
        (expire ? ';expires=' + date.toGMTString() : '')
}



// WEBPACK FOOTER //
// ./src/utils/Session.js